export default __webpack_public_path__ + "static/media/cryptocoins.79e8ee53.ttf";